// extracted by mini-css-extract-plugin
export var chevronIcon = "_aj-2";
export var teamName = "_aj-1";
export var teamSwitcherButton = "_aj-0";